export default __webpack_public_path__ + "static/media/013-coat-stand.d4b407ea.svg";